<template>
  <div>
    <div class="md-layout" v-bind:style="style_list()">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>person_pin</md-icon>
            </div>
            <h4 class="title">Profissionais</h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-70 md-xsmall-size-100" style="padding-left: 0px">
                <filtro_simples
                  v-model="searchQuery"
                  placeholder="Filtrar por peso"
                  :disabled="carregando"
                  :onSearch="load_data"
                ></filtro_simples>
              </div>

              <div class="md-layout-item md-size-30 md-xsmall-size-100">
                <md-button
                  title="Adicionar"
                  class="md-round md-just-icon md-info pull-right"
                  v-on:click="add_new"
                  type="button"
                >
                  <md-icon>add</md-icon>
                </md-button>
              </div>
            </div>

            <md-table
              :value="queriedData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover"
            >
              <md-table-toolbar v-if="false">
                <md-field>
                  <md-input
                    type="search"
                    class="mb-6"
                    clearable
                    style="width: 400px"
                    placeholder="Pesquisar"
                    v-model="searchQuery"
                    @keyup.enter="enter"
                  ></md-input>
                </md-field>

                <md-field>
                  <label for="pages">Exibir por {{Termos.Pagina}}:</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >{{ item }}</md-option>
                  </md-select>
                </md-field>

                <md-button
                  title="Adicionar"
                  class="md-round md-just-icon md-info pull-right"
                  v-on:click="add_new"
                  type="button"
                >
                  <md-icon>add</md-icon>
                </md-button>
              </md-table-toolbar>
              <div>
                <br />
              </div>

              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell class="table-col-btn" md-label=" ">
                  <md-button
                    class="md-just-icon md-info md-simple"
                    @click.native="handleLike(item)"
                  >
                    <md-icon>edit</md-icon>
                  </md-button>
                </md-table-cell>
                <md-table-cell md-label="id" md-sort-by="id">{{item.id}}</md-table-cell>
                <md-table-cell class="table-col-big" md-label="Nome" md-sort-by="nome">{{item.nome}}</md-table-cell>
                <md-table-cell md-label="CPF" md-sort-by="cpf">{{item.cpf}}</md-table-cell>
                <md-table-cell md-label="Fonte" md-sort-by="fone">{{item.fone}}</md-table-cell>
                <md-table-cell md-label="Celular" md-sort-by="celular">{{item.celular}}</md-table-cell>

                <md-table-cell md-label="Cidade" md-sort-by="cidade">{{item.cidade}}</md-table-cell>
                <md-table-cell md-label="Estado" md-sort-by="estado">{{item.estado}}</md-table-cell>
              </md-table-row>
            </md-table>
            <div class="footer-table md-table">
              <table>
                <tfoot>
                  <tr v-if="carregando">
                    <th>
                      <div class="md-table-head-container md-ripple md-disabled">
                        <div class="md-table-head-label">
                          <i>Carregando..</i>
                        </div>
                      </div>
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class>
              <p
                class="card-category"
              >Mostrando {{ from + 1 }} {{Termos.Ate}} {{ to }} de {{ total }} resultados</p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></pagination>
          </md-card-actions>
        </md-card>
      </div>
    </div>

    <div v-if="action =='form'">
      <nutricionista_form
        v-bind:id_load="form.id"
        v-bind:onSave="onSave"
        show_back_button="true"
        v-bind:onBack="onBack"
      ></nutricionista_form>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import service from "../../../services/NutricionistaService";
import nutricionista_form from "./Form";
import impTermos from "../../../library/Termos";
import filtro_simples from "../../components/filtro_simples.vue";
import Alerta from "../../../library/Alerta";
import $ from "jquery";
import serviceUsuario from "../../../services/UsuarioService";

export default {
  components: {
    Pagination,
    nutricionista_form,
    filtro_simples
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      currentSort: "nome",
      currentSortOrder: "asc",
      carregando: true,
      pagination: {
        perPage: 6,
        currentPage: 1,
        perPageOptions: [6, 10, 25, 50],
        total: 0
      },
      footerTable: ["Nome", "Email", "Perfil"],
      searchQuery: "",
      propsToSearch: ["name", "email", "perfil"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      action: "list",
      form: null,
      Termos: impTermos
    };
  },
  methods: {
    style_list() {
      if (this.action == "form") {
        return "display:none";
      }
      return "";
    },
    customSort(value) {
      // console.log(  this.currentSort +" - " +  this.currentSortOrder );
      this.load_data();
    },
    handleLike(item) {
      this.form = item;
      this.action = "form";
    },

    onBack(objPost) {
      //Clicou no back button.
      this.form = null; //Voltando para a lista
      this.action = "list";
      this.clean_back_button();
    },

    onSave(obj, acao) {
      this.load_data();

      if (acao == "save") {
        Alerta.show(
          "Sucesso!",
          "Registro salvo com sucesso!",
          "success",
          null,
          3000
        );
      }

      if (acao == "delete") {
        if ($ != null && $ != undefined) {
          var divs = $(".main-panel");
          // console.log(divs);
          if (divs != null && divs.length > 0) {
            //divs[0].scrollHeight
            $(divs[0]).scrollTop();
          }
        }
        //console.log("Consegui fazer o scroll?");

        Alerta.show(
          "Sucesso!",
          "Registro excluído com sucesso!",
          "success",
          function() {},
          3000
        );
      }
    },
    handleEdit(item) {
      this.form = item;
      this.action = "form";
    },
    add_new(e) {
      e.preventDefault();
      this.form = service.getModel();
      this.action = "form";
    },
    load_data() {
      let self = this;
      self.carregando = true;

      var query = this.searchQuery;

      if (query == null) {
        query = "";
      }

      service
        .getList(query, this.currentSort, this.currentSortOrder)
        .then(function(response) {
          self.tableData = response.data;
          self.carregando = false;
        });
    },
    enter(e) {
      e.preventDefault();

      this.load_data();
    },
    clean_back_button() {
      this.$store.dispatch("setButtonBack", {
        in_form: false,
        rota: "nutricionista",
        exibe: false,
        onBack: null
      });
    }
  },
  mounted() {
    var pageSize = serviceUsuario.getPageSize();
    this.pagination.perPage = pageSize;
    this.load_data();
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
